import { Injectable } from '@angular/core';

import { isLancamentoAutomatico } from '../atividade-lancamento';

/** Service que valida o acessos as telas dos status das Cotações */
@Injectable({
    providedIn: 'root'
})
export class AtividadeAuthGuardService {

    /** Verifica se pode excluir a atividade */
    canDelete(lancamento: number): boolean {
        // Se for um lançamento automático não pode excluir
        return !isLancamentoAutomatico(lancamento);
    }
}
